export default __webpack_public_path__ + "static/media/raki_detail12.db310c43.jpg";